export default __webpack_public_path__ + "static/media/ticket.48ba6b6e.svg";